import React, { useEffect, useState } from 'react';

import ShareLogo from '../../assets/svg/share.svg';
import CloseLogo from '../../assets/svg/close.svg';
import VK from '../../assets/svg/vk.svg';
import TG from '../../assets/svg/tg.svg';
import TW from '../../assets/svg/tw.svg';
import OK from '../../assets/svg/ok.svg';
import share from '../../helpers/share';
import { SocialId } from '../../utils/constant';
import useMobile from '../../hooks/useMobile';
import ClickOutside from '../../helpers/ClickOutside';

import classes from './shareBlock.module.scss';

import { analytics, AnalyticsShow } from 'src/utils/analytics';
import { useStorage } from '@/models/Storage';

type ShareBlockProps = {
    foldable?: boolean;
    result?: boolean;
};

export const ShareBlock = ({ foldable, result = false }: ShareBlockProps) => {
    const [opened, setOpened] = useState(false);
    const [mounted, setMounted] = useState(false);

    const {} = useStorage();

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (!foldable) return;
        if (!opened) return;

        const toggle = () => setOpened(false);

        window.addEventListener('click', toggle, { capture: true });
        return () => window.removeEventListener('click', toggle, { capture: true });
    }, [opened, foldable]);

    const toggleOpened = () => setOpened(!opened);

    if (!mounted) return null;

    if (foldable) {
        return (
            <div className={`${classes.shareBlock} ${opened ? classes.opened : ''}`}>
                {opened ? (
                    <CloseLogo
                        className={`${classes.visible} `}
                        onClick={() => {
                            toggleOpened();
                        }}
                    />
                ) : (
                    <ShareLogo
                        className={`${classes.visible} `}
                        onClick={() => {
                            toggleOpened();
                        }}
                    />
                )}
                <ClickOutside
                    className={classes.hiddenWrapper}
                    onClickOutside={() => {
                        if (opened) setOpened(false);
                    }}
                >
                    <div className={classes.hidden}>
                        <a
                            className={classes.vk}
                            href={share(SocialId.Vk, mounted, result)}
                            suppressHydrationWarning
                            onClick={() => {
                                switch (result) {
                                    default:
                                        return analytics(
                                            result
                                                ? AnalyticsShow.ResultShareVK
                                                : AnalyticsShow.ShareVK,
                                        );
                                }
                            }}
                        >
                            <div className={`btnIcon social`}>
                                <div className="btnWrapper">
                                    <div className="icon">
                                        <VK className={''} />
                                    </div>
                                </div>
                            </div>
                        </a>
                        <a
                            className={classes.telegram}
                            href={share(SocialId.Tg, mounted, result)}
                            suppressHydrationWarning
                            onClick={() => {
                                switch (result) {
                                    default:
                                        return analytics(
                                            result
                                                ? AnalyticsShow.ResultShareTG
                                                : AnalyticsShow.ShareTG,
                                        );
                                }
                            }}
                        >
                            <div
                                className={`btnIcon social offset`}
                                // onClick={() => adFox('', !isResult ? 'shareTG' : 'shareResultTG')}
                            >
                                <div className="btnWrapper">
                                    <div className="icon">
                                        <TG className={''} />
                                    </div>
                                </div>
                            </div>
                        </a>
                        <a
                            className={classes.ok}
                            href={share(SocialId.Ok, mounted, result)}
                            suppressHydrationWarning
                            onClick={() => {
                                switch (result) {
                                    default:
                                        return analytics(
                                            result
                                                ? AnalyticsShow.ResultShareOK
                                                : AnalyticsShow.ShareOK,
                                        );
                                }
                            }}
                        >
                            <div
                                className={`btnIcon social`}
                                // onClick={() => adFox('', !isResult ? 'shareOK' : 'shareResultOK')}
                            >
                                <div className="btnWrapper">
                                    <div className="icon">
                                        <OK className={''} />
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </ClickOutside>
            </div>
        );
    } else {
        return (
            <div className={classes.shareList}>
                <a
                    className={classes.vk}
                    href={share(SocialId.Vk, mounted, result)}
                    suppressHydrationWarning
                    onClick={() => {
                        switch (result) {
                            default:
                                return analytics(AnalyticsShow.ShareVK);
                        }
                    }}
                >
                    <div
                        className={`btnIcon social`}
                        // onClick={() => adFox('', '', !isResult ? 'shareVK' : 'shareResultVK')}
                    >
                        <div className="btnWrapper">
                            <div className="icon">
                                <VK className={''} />
                            </div>
                        </div>
                    </div>
                </a>
                <a
                    className={classes.telegram}
                    href={share(SocialId.Tg, mounted, result)}
                    suppressHydrationWarning
                    onClick={() => {
                        switch (result) {
                            default:
                                return analytics(AnalyticsShow.ShareTG);
                        }
                    }}
                >
                    <div
                        className={`btnIcon social offset`}
                        // onClick={() => adFox('', !isResult ? 'shareTG' : 'shareResultTG')}
                    >
                        <div className="btnWrapper">
                            <div className="icon">
                                <TG className={''} />
                            </div>
                        </div>
                    </div>
                </a>
                <a
                    className={classes.ok}
                    href={share(SocialId.Ok, mounted, result)}
                    suppressHydrationWarning
                    onClick={() => {
                        switch (result) {
                            default:
                                return analytics(AnalyticsShow.ShareOK);
                        }
                    }}
                >
                    <div
                        className={`btnIcon social`}
                        // onClick={() => adFox('', !isResult ? 'shareOK' : 'shareResultOK')}
                    >
                        <div className="btnWrapper">
                            <div className="icon">
                                <OK className={''} />
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        );
    }
};
